// frontend/src/components/SiteSelector.js
// Phase 8: Role-aware Site Selector
// - UPS users see company-owned sites
// - Agency users see contract-allowed sites
// - selectedSiteId is global and used for site-scoped views

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  ALL_SITES,
  selectCompanySites,
  selectAgencyAllowedSites,
  selectSelectedSiteIdRaw,
  selectSitesLoading,
  setSelectedSiteId,
} from '../features/sites/sitesSlice';
import { selectUserRole } from '../features/auth/authSlice';

export default function SiteSelector() {
  const dispatch = useDispatch();
  const siteSelectId = 'site-selector';
  const controlClass =
    'w-full min-w-0 rounded-xl border border-app-border bg-app-card px-4 py-3 text-sm text-app-text outline-none transition focus:border-app-primary focus:ring-2 focus:ring-app-accent/30';
  const messageClass =
    'w-full min-w-0 rounded-xl border border-app-border bg-app-surface px-4 py-3 text-sm leading-5 text-app-muted';

  const role = useSelector(selectUserRole);
  const selectedSiteId = useSelector(selectSelectedSiteIdRaw);
  const loading = useSelector(selectSitesLoading);

  const isAgencyUser = role === 'agency_admin' || role === 'agency_user';
  const sites = useSelector(isAgencyUser ? selectAgencyAllowedSites : selectCompanySites);

  return (
    <div className="w-full min-w-0">
      <label
        htmlFor={siteSelectId}
        className="mb-2 block text-xs font-semibold uppercase tracking-[0.22em] text-app-muted"
      >
        Site
      </label>

      {loading ? (
        <div className={messageClass}>
          Loading sites…
        </div>
      ) : !sites.length ? (
        <div className={messageClass}>
          {isAgencyUser ? 'No contract-allowed sites available.' : 'No sites found for this company.'}
        </div>
      ) : (
        <select
          id={siteSelectId}
          name="siteId"
          value={selectedSiteId ?? ''}
          onChange={(e) => dispatch(setSelectedSiteId(e.target.value))}
          className={controlClass}
        >
          {!isAgencyUser && (
            <option value={ALL_SITES}>All Sites</option>
          )}

          {sites.map((s) => (
            <option key={s.id} value={s.id}>
              {s.name}{s.code ? ` (${s.code})` : ''}
            </option>
          ))}
        </select>
      )}
    </div>
  );
}
